import axiosInstance from './AxiosService';

const processNarrativeService = {
    // Fetch all narrative versions for an application
    fetchNarrativeVersions: async (appId) => {
        try {
            const response = await axiosInstance.get(`process/narrative/versions/${appId}/`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching narrative versions for app ${appId}:`, error);
            throw error;
        }
    },

    // Fetch a specific narrative version
    fetchNarrativeVersion: async (versionId) => {
        try {
            const response = await axiosInstance.get(`process/narrative/version/${versionId}/`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching narrative version ${versionId}:`, error);
            throw error;
        }
    },

    // Create a new version from the current narrative
    createNarrativeVersion: async (appId, narrativeData) => {
        try {
            const response = await axiosInstance.post(`process/narrative/create-version/${appId}/`, narrativeData);
            return response.data;
        } catch (error) {
            console.error(`Error creating narrative version for app ${appId}:`, error);
            throw error;
        }
    },

    // Update an existing narrative version
    updateNarrativeVersion: async (versionId, narrativeData) => {
        try {
            const response = await axiosInstance.put(`process/narrative/update-version/${versionId}/`, narrativeData);
            return response.data;
        } catch (error) {
            console.error(`Error updating narrative version ${versionId}:`, error);
            throw error;
        }
    },

    // Certify a narrative version
    certifyNarrativeVersion: async (versionId, certificationData) => {
        try {
            const response = await axiosInstance.post(`process/narrative/certify/${versionId}/`, certificationData);
            return response.data;
        } catch (error) {
            console.error(`Error certifying narrative version ${versionId}:`, error);
            throw error;
        }
    },

    // Certify the current narrative without specifying a version ID
    certifyCurrentNarrative: async (appId, certificationData) => {
        try {
            if (!appId) {
                throw new Error("app_id is required");
            }
            
            const data = {
                app_id: appId,
                ...certificationData
            };
            console.log("Sending certification request with data:", data); // Debug log
            const response = await axiosInstance.post(`process/narrative/certify/current/`, data);
            return response.data;
        } catch (error) {
            console.error(`Error certifying current narrative for app ${appId}:`, error);
            throw error;
        }
    },

    // Fetch certification history for an application
    fetchCertificationHistory: async (appId) => {
        try {
            const response = await axiosInstance.get(`process/narrative/certifications/${appId}/`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching certification history for app ${appId}:`, error);
            throw error;
        }
    },

    // Get the comparison between two narrative versions
    compareNarrativeVersions: async (versionId1, versionId2) => {
        try {
            const response = await axiosInstance.get(`process/narrative/compare/${versionId1}/${versionId2}/`);
            return response.data;
        } catch (error) {
            console.error(`Error comparing narrative versions ${versionId1} and ${versionId2}:`, error);
            throw error;
        }
    },

    // Get the latest certified version
    getLatestCertifiedVersion: async (appId) => {
        try {
            const response = await axiosInstance.get(`process/narrative/latest-certified/${appId}/`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching latest certified version for app ${appId}:`, error);
            return null; // Return null instead of throwing to allow component to handle this gracefully
        }
    },

    // Check certification status (useful for showing warning banner)
    checkCertificationStatus: async (appId) => {
        try {
            const response = await axiosInstance.get(`process/narrative/certification-status/${appId}/`);
            return response.data;
        } catch (error) {
            console.error(`Error checking certification status for app ${appId}:`, error);
            return {
                lastCertified: null,
                needsCertification: true,
                daysSinceLastCertification: null
            };
        }
    }
};

export default processNarrativeService; 